"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _toolkit = require('@reduxjs/toolkit');

var _common = require('shared/selectors/blobject/common');

var _team = require('shared/selectors/team');
var _peers = require('shared/selectors/peers');
var _uuid = require('shared/services/uuid');
var _sendingNumber = require('shared/services/composer/sendingNumber');

const UNKNOWN = { kind: 'unknown' }

// The number a plain SMS from this chat goes out from, by the server's rule
// (determineSendingNumber), whichever of the chat's teams I'm on.
 const selectSendingNumber = _toolkit.createSelector.call(void 0, 
  _common.selectBlobjectByKey,
  _team.selectAllTeams,
  _peers.selectAllPatients,
  (blobject, teams, patients) => {
    if (!blobject) return UNKNOWN
    const [patientKey] = Object.keys(_nullishCoalesce(blobject.PatientSubscribers, () => ( {}))) 
    const patient = patientKey ? _optionalChain([patients, 'optionalAccess', _ => _[patientKey]])  : null
    const orgKey = patient === null ? null : _optionalChain([patient, 'optionalAccess', _2 => _2.OrgKey])
    return _sendingNumber.determineSendingNumber.call(void 0, {
      chatTeamKeys: Object.keys(blobject.TeamSubscribers),
      teams,
      patientOrgKey: orgKey === _uuid.EMPTY_BLUID ? null : orgKey,
      // The client doesn't hold every team of the patient's org.
      orgTeams: undefined,
    })
  },
); exports.selectSendingNumber = selectSendingNumber
